import request from '@/utils/request'

export function allowClazzType () {
  return request({
    url: '/front/manage/user/clazz_type/',
    method: 'get'
  })
}

export function allowRuleList (query) {
  return request({
    url: '/front/manage/user/rule/',
    method: 'get',
    params: query
  })
}

export function ruleInfo (id) {
  return request({
    url: '/front/manage/user/rule/' + id + '/',
    method: 'get'
  })
}

export function addClazz (data) {
  return request({
    url: '/front/manage/clazz/create/',
    method: 'post',
    data
  })
}

export function manageClazzList () {
  return request({
    url: '/front/manage/clazz/list/',
    method: 'get'
  })
}

export function manageClazzUserList (clazzId) {
  return request({
    url: '/front/manage/clazz/' + clazzId + '/user/list/',
    method: 'get'
  })
}

export function editClazz (clazzId, data) {
  return request({
    url: '/front/manage/clazz/' + clazzId + '/update/',
    method: 'patch',
    data
  })
}

export function deleteClazz (clazzId) {
  return request({
    url: '/front/manage/clazz/' + clazzId + '/delete/',
    method: 'post'
  })
}
